// Third Party Imports
import React from 'react';

// Relative Imports
import './Footer.less';

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            translations, skipComponent
        } = this.props;

        return ((skipComponent)
            ? null
            : <footer>
                <div className="page-footer">
                    <div className="footer-text-holder">
                        {
                            // eslint-disable-next-line react/no-danger
                            <div dangerouslySetInnerHTML={{__html: translations['ipmob.footer.description_1']}}/>
                        }
                        <div>{translations['ipmob.footer.description_2']}</div>
                    </div>
                </div>
            </footer>);
    }
}
